import Reveal from "@/components/Reveal";

export default function Cinema({ t }) {
  const videos = [
    { src: "/videos/banco.mp4", poster: "/videos/banco-poster.jpg", caption: t.cinema.cap1, testid: "video-banco" },
    { src: "/videos/frutta.mp4", poster: "/videos/frutta-poster.jpg", caption: t.cinema.cap2, testid: "video-frutta" },
  ];

  return (
    <section data-testid="cinema-section" className="bg-[#1E1614] text-[#FAF7F2] py-20 sm:py-28 lg:py-32 overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-12">
        <Reveal className="text-center max-w-2xl mx-auto">
          <p className="font-accent text-xs uppercase tracking-[0.25em] text-[#C86D51] mb-4">
            {t.cinema.over}
          </p>
          <h2 className="font-display tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.1]">
            {t.cinema.title}
          </h2>
          <p className="mt-5 text-base sm:text-lg leading-relaxed text-[#FAF7F2]/65">
            {t.cinema.sub}
          </p>
        </Reveal>

        <div className="mt-12 sm:mt-16 grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-10 max-w-3xl mx-auto">
          {videos.map((v, i) => (
            <Reveal key={v.src} delay={i * 0.15}>
              <figure>
                <video
                  src={v.src}
                  poster={v.poster}
                  data-testid={v.testid}
                  autoPlay
                  muted
                  loop
                  playsInline
                  preload="metadata"
                  className="w-full aspect-[9/16] object-cover rounded-3xl border border-[#FAF7F2]/10 shadow-2xl shadow-black/40"
                />
                <figcaption className="mt-4 text-center font-accent text-[11px] uppercase tracking-[0.2em] text-[#FAF7F2]/60">
                  {v.caption}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
